import axios from '@/http/apiRequest'

// 任务列表分页
export const queryTaskPage = ({ hostCode, current = 1, pageSize = 20}, data) => {
  return axios.request({
    method: 'POST',
    url: `/api/task/queryPage/${hostCode}/${current}/${pageSize}`,
    data,
  })
}

// 任务列表无分页
export const queryTaskList = ({ hostCode }) => {
  return axios.request({
    method: 'GET',
    url: `/api/task/queryList/${hostCode}`
  })
}

// 更新任务数据
export const updateTask = (taskId) => {
  return axios.request({
    method: 'POST',
    url: `/api/task/updateTask/${taskId}`,
    data: { notifyStatus: 1 },
  })
}

export const stopTask = (taskId) => {
  return axios.request({
    method: 'GET',
    url: `/api/task/stopTask/${taskId}`
  })
}

export const deleteTask = (taskId) => {
  return axios.request({
    method: 'GET',
    url: `/api/task/deleteTask/${taskId}`
  })
}

// 查询网站搬家任务数据
export const getCloneInfo = (taskCode) => {
  return axios.request({
    method: 'GET',
    url: `/api/siteMove/getCloneInfo/${taskCode}`
  })
}

export const getTaskLock = (taskCode) => {
  return axios.request({
    method: 'GET',
    url: `/api/task/lock/${taskCode}`
  })
}

// 查询任务详情

export const getTaskDetail = (hostCode,params) => {
  return axios.request({
    method: 'GET',
    url: `/api/task/getTask/${hostCode}`,
    params
  })
}